import Fintrac from '../hoc/fintrac';
import FintracReport from '../hoc/fintrac/parts/report';
import CreateReport from '../hoc/fintrac/parts/create-report';
import ReportDetails from '../hoc/fintrac/parts/details';
import FintracReports from '../hoc/fintrac/reports';

import ROUTES from '../routes';

const FintracRoutes = {
  path: ROUTES.FINTRAC,
  element: <Fintrac />,
  children: [
    {
      path: ROUTES.FINTRAC_REPORTS,
      element: <FintracReports />,
      children: [
        {
          path: ROUTES.FINTRAC_EFTR,
          element: <FintracReport type="eftr" />,
          children: [
            {
              path: ROUTES.FINTRAC_EFTR_CREATE,
              element: <CreateReport type="eftr" />,
            },
          ],
        },
        {
          path: ROUTES.FINTRAC_LVCTR,
          element: <FintracReport type="lvctr" />,
          children: [
            {
              path: ROUTES.FINTRAC_LVCTR_CREATE,
              element: <CreateReport type="lvctr" />,
            },
          ],
        },
      ],
    },

    {
      path: ROUTES.FINTRAC_DETAILS,
      element: <ReportDetails />,
    },
  ],
};

export default FintracRoutes;
